import { createFileRoute } from '@tanstack/react-router';
import { JoinScreen } from '@/components/JoinScreen';

/** QR target: /j/KMX4TQ — code prefilled (05 §2.4). */
export const Route = createFileRoute('/j/$code')({
  component: JCode,
});

function JCode() {
  const { code } = Route.useParams();
  return <JoinScreen initialCode={code} />;
}
